import { createOffice, getOffices } from "../api/officeService";

export const useCreateOffice = (setOffices) => {
    const create = async (data) => {
    try {
        const response = await createOffice(data);
        const newOffice = response;

        // Instead of appending, re-fetch the latest offices list
        const officesResponse = await getOffices();
        setOffices(officesResponse);

        return newOffice; // still return the created office if caller needs it
    } 
    catch (error) {
        console.error("Error creating office:", error);
        throw error;
    }
  };

  return { create };
};